import * as React from 'react';
/**
 *
 * Original name: Dropbox Sign
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=34816%3A9689
 *
 */
export const DropboxSignLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m13.322 8.503 5.88-4.05v5.21l-2.105 1.44-3.775-2.6Zm-2.644 0-5.88-4.05v5.21l2.105 1.44 3.775-2.6Zm-5.879 5.871L11.25 9.93v5.178L4.8 19.546v-5.172Zm7.951.734V9.931l6.451 4.443v5.173l-6.45-4.439Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
